import { FDCNotificationEvent } from '@cims-online/shared'
import CIMSFormItem from 'components/CIMSFormItem'
import CommonFormItems from './components/CommonFormItems'
import TwoDimensionalGroupFormItems from './components/TwoDimensionalGroupFormItems'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'

const RenderFormItems: React.FC = () => {
  const { event } = useCIMSNotificationsPanelContext()
  let children
  if (event === FDCNotificationEvent.GroupApproved)
    children = (
      <CIMSFormItem name="approvalGroup">
        <TwoDimensionalGroupFormItems group="Approval Group" />
      </CIMSFormItem>
    )
  else if (event === FDCNotificationEvent.AnyLevelConcurred)
    children = (
      <CIMSFormItem name="concurrenceGroup">
        <TwoDimensionalGroupFormItems group="Concurrence Group" />
      </CIMSFormItem>
    )
  else children = null
  return <CommonFormItems>{children}</CommonFormItems>
}

export default RenderFormItems
